import { CSSObject } from "@emotion/react";
import { theme } from "components/lib/utils";

export const jobCard: CSSObject = {
  padding: `${theme.space[5]} ${theme.space[5]}`,
};
